import groq from 'groq'

export const benefits = groq`
  _type,
  title,
  list[]{
    ...,
    "icon": icon->slug,
  }, 
`
